import { render, staticRenderFns } from "./SemipolarSpinner.vue?vue&type=template&id=9544fc1a&scoped=true&"
import script from "./SemipolarSpinner.vue?vue&type=script&lang=js&"
export * from "./SemipolarSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SemipolarSpinner.vue?vue&type=style&index=0&id=9544fc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9544fc1a",
  null
  
)

export default component.exports